/**
 * Actions for pages module
 */

import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchPage(payload) {
  return { type: actionTypes.FETCH_PAGE, payload };
}
export function fetchPageSuccess(payload) {
  const byId = { [payload.pageUid]: payload };
  return { type: actionTypes.FETCH_PAGE_SUCCESS, payload: { byId } };
}
export function fetchPages(payload) {
  return { type: actionTypes.FETCH_PAGES, payload };
}
export function fetchPagesSuccess(pages) {
  const byId = keyBy(pages, (page) => page.pageUid);
  return {
    type: actionTypes.FETCH_PAGES_SUCCESS,
    payload: { byId },
  };
}
export function clearPages() {
  return { type: actionTypes.CLEAR_PAGES };
}
export function savePage(payload) {
  return { type: actionTypes.SAVE_PAGE, payload };
}
export function savePageSuccess(payload) {
  return { type: actionTypes.SAVE_PAGE_SUCCESS, payload };
}
export function updatePageSortOrder(payload) {
  return { type: actionTypes.UPDATE_PAGE_SORT_ORDER, payload };
}
export function updatePageSortOrderSuccess(payload) {
  return { type: actionTypes.UPDATE_PAGE_SORT_ORDER_SUCCESS, payload };
}
export function updatePage(payload) {
  return { type: actionTypes.UPDATE_PAGE, payload };
}
export function updatePageSuccess(payload) {
  return { type: actionTypes.UPDATE_PAGE_SUCCESS, payload };
}
export function deletePage(payload) {
  return { type: actionTypes.DELETE_PAGE, payload };
}
export function deletePageSuccess(payload) {
  return { type: actionTypes.DELETE_PAGE_SUCCESS, payload };
}
